
<template>
    <button type="button" class="btn btn-sm btn-outline-dark mb-3" @click="openCreateModal()">
        <i class="fas fa-plus"></i> Nouveau trajet
    </button>

    <DataTableBackend :url="'/api/'+table" :columns="columns" :table="table" :perPage="6">
        <template #action_btns=slotProps>
            <button class="btn btn-sm btn-light m-1" @click="openShowModal(slotProps.data)">
                <i class="fa-solid fa-ellipsis"></i>
            </button>
        </template>
    </DataTableBackend>
</template>
  
<script >
import { defineComponent, defineAsyncComponent } from 'vue';
const ShowTrajet = defineAsyncComponent(() => import('./ShowTrajet.vue'));
const CreateTrajet = defineAsyncComponent(() => import('./CreateTrajet.vue'));

export default defineComponent({
    name: 'IndexTrajet',
    data() {
        return {
            table: 'trajets',
            baseUrl: this.$store.state.api_yams_livraisons,
            columns: [
                {
                    key: 'libelle',
                    label: 'Libelle',
                    exportable: true
                },
                {
                    key: 'montant',
                    label: 'Montant',
                    format: 'money',
                    exportable: true
                },
            ]
        };
    },
    methods: {
        openCreateModal() {
            this.$dialog.open(CreateTrajet, {
                props: {
                    header: "Nouveau trajet",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        openShowModal(objData) {
            this.$dialog.open(ShowTrajet, {
                props: {
                    header: "Trajet N°" + objData.id,
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        
    },
});
</script>
    
  